
(function() {
  var result = { translations: { "zh-cn": { "i18n": { "duration": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u949F", "hours": "{{ hours }} \u5C0F\u65F6", "hoursAndMinutes": "{{ hours }} \u5C0F\u65F6 {{ minutes }} \u5206\u949F", "days": "{{ days }} \u5929", "shortForm": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u949F", "hours": "{{ hours }} \u5C0F\u65F6", "days": "{{ days }} \u5929", "hoursAndMinutes": "{{ hours }} \u5C0F\u65F6 {{ minutes }} \u5206\u949F" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} \u5E74\u7B2C {{quarterNumber}} \u5B63\u5EA6" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\uFF0C\u5206\u673A {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "zh-cn": "static-7.1050"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1050",
    "ar-eg": "static-7.1050",
    "bg": "static-7.1050",
    "bn": "static-7.1050",
    "ca-es": "static-7.1050",
    "cs": "static-7.1050",
    "da": "static-7.1050",
    "de": "static-7.1050",
    "el": "static-7.1050",
    "en-gb": "static-7.1050",
    "en": "static-7.1050",
    "es-mx": "static-7.1050",
    "es": "static-7.1050",
    "et": "static-7.1050",
    "fi": "static-7.1050",
    "fr-ca": "static-7.1050",
    "fr": "static-7.1050",
    "he-il": "static-7.1050",
    "hi": "static-7.1050",
    "hr": "static-7.1050",
    "hu": "static-7.1050",
    "id": "static-7.1050",
    "it": "static-7.1050",
    "ja": "static-7.1050",
    "ko": "static-7.1050",
    "lt": "static-7.1050",
    "ms": "static-7.1050",
    "nl": "static-7.1050",
    "no": "static-7.1050",
    "pl": "static-7.1050",
    "pt-br": "static-7.1050",
    "pt-pt": "static-7.1050",
    "ro": "static-7.1050",
    "ru": "static-7.1050",
    "sk": "static-7.1050",
    "sl": "static-7.1050",
    "sv": "static-7.1050",
    "th": "static-7.1050",
    "tl": "static-7.1050",
    "tr": "static-7.1050",
    "uk": "static-7.1050",
    "vi": "static-7.1050",
    "x-pseudo": "static-7.1050",
    "zh-cn": "static-7.1050",
    "zh-hk": "static-7.1050",
    "zh-tw": "static-7.1050"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-cn', {version: 'static-7.1050'}); }
})();


